import * as React from 'react';
import AfrDataImportCore from '../AfrCore/AfrDataImportCore';




const AfrDataImport = (props: any) => {

    return (
        <React.Fragment>
            <AfrDataImportCore userRole="ENTITY_USER"/>
        </React.Fragment>
    );
}

export default AfrDataImport;